export default function ErrorBoundary() {
  return (
    <>
      <div className="flex justify-center items-center h-screen">
        <h1>There was a problem. Contact our support team to get help</h1>
      </div>
    </>
  );
}
